import { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export interface IPaginator {
  search: string;
  perPage: number;
  page: number;
  sort: any;
}

const useTablePagination = (): {
  search: string;
  setSearch: (search: string) => void;
  perPage: number;
  setPerPage: (page: number) => void;
  page: number;
  setPage: (page: number) => void;
  sort: any;
  setSort: (sort: any) => void;
} => {
  const [pagination, setPagination] = useState<IPaginator>({
    search: '',
    perPage: 25,
    page: 1,
    sort: null
  });

  const handleDebouncePage = useDebouncedCallback((pageNo: number) => {
    setPagination({ ...pagination, page: pageNo });
  }, 1000);

  const handleSearch = (search: string) => setPagination({ ...pagination, page: 1, search });
  const handlePerPage = (perPage: number) => setPagination({ ...pagination, perPage });
  const handleSort = (sort: any) => setPagination({ ...pagination, sort });

  return {
    search: pagination.search,
    setSearch: handleSearch,
    perPage: pagination.perPage,
    setPerPage: handlePerPage,
    page: pagination.page,
    setPage: handleDebouncePage,
    sort: pagination.sort,
    setSort: handleSort
  };
};

export default useTablePagination;
